import { api } from "../utils/api";
import type {
  RestCreateProductGroup,
  RestProductGroup,
  RestUpdateProductGroup,
} from "@KassaroAB/shared/types/productGroup";
import type { ProductGroupId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const productGroupsPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "productGroups");

export const getProductGroupsApi = (
  scope: CatalogScope,
): Promise<RestProductGroup[]> => {
  return api.get(productGroupsPath(scope));
};

export const getProductGroupApi = (
  scope: CatalogScope,
  groupId: ProductGroupId,
): Promise<RestProductGroup> => {
  return api.get(`${productGroupsPath(scope)}/${groupId}`);
};

export const createProductGroupApi = (
  scope: CatalogScope,
  group: RestCreateProductGroup,
): Promise<RestProductGroup> => {
  return api.post(productGroupsPath(scope), group);
};

export const updateProductGroupApi = (
  scope: CatalogScope,
  groupId: ProductGroupId,
  group: RestUpdateProductGroup,
): Promise<RestProductGroup> => {
  return api.put(`${productGroupsPath(scope)}/${groupId}`, group);
};

export const deleteProductGroupApi = (
  scope: CatalogScope,
  groupId: ProductGroupId,
): Promise<void> => {
  return api.delete(`${productGroupsPath(scope)}/${groupId}`);
};
